import { render, staticRenderFns } from "./interfaceUpdate.vue?vue&type=template&id=61def90f&scoped=true"
import script from "./interfaceUpdate.vue?vue&type=script&lang=js"
export * from "./interfaceUpdate.vue?vue&type=script&lang=js"
import style0 from "./interfaceUpdate.vue?vue&type=style&index=0&id=61def90f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61def90f",
  null
  
)

export default component.exports